"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,2 C17.5227273,2 22,6.47704545 22,12 C22,17.5229545 17.5227273,22 12,22 C6.47727273,22 2,17.5229545 2,12 C2,6.47704545 6.47727273,2 12,2 Z M16.5200193,8.98135163 C16.1469184,8.60872882 15.541055,8.60880279 15.1678348,8.98154502 L15.1678348,8.98154502 L10.9389153,13.2107635 L9.16283652,11.4346847 C8.78949694,11.0613451 8.18431639,11.0613451 7.81069249,11.43473 C7.43740574,11.8077778 7.43740574,12.4135014 7.81071277,12.7870475 L7.81071277,12.7870475 L10.2627164,15.2381841 C10.635767,15.6112347 11.2415256,15.6112347 11.6148194,15.23818 L11.6148194,15.23818 L16.5195943,10.333694 C16.893265,9.95978409 16.8935605,9.35489292 16.5200193,8.98135163 Z"
  });
}.bind(void 0));

exports.default = _default;